// Copyright 2026, Imprivata, Inc.  All rights reserved.

import type { KeyboardEvent } from 'react';

// Blocks typed characters outside `allowed`; shortcuts and named keys such as Backspace pass.
export const keyFilter = (allowed: RegExp) => (e: KeyboardEvent<HTMLInputElement>) => {
  if (e.ctrlKey || e.metaKey || e.key.length > 1 || allowed.test(e.key)) {
    return;
  }
  e.preventDefault();
};
